<template>
  <div class="amazon_pay_area">
    <div id="AmazonPayButton"></div>
    <div v-show="payMethod" class="pay_method">
      <div>Payment Method</div>
      <div>{{ payMethod }}</div>
      <div class="btn_area">
        <SquareButton
          id="ChangePayment"
          class="square-button"
          text="Change"
          :isSub="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SquareButton from '@/components/atoms/SquareButton.vue';

export default {
  name: 'AmazonPayButton',
  components: {
    SquareButton,
  },
  data: () => ({
    payMethod: '',
  }),
  mounted() {
    const script = document.createElement('script');
    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
    document.body.appendChild(script);
    this.$nextTick(function () {
      if (this.$route.query.amazonCheckoutSessionId) {
        // AmazonPayボタンからリダイレクトされてきた場合
        this.$emit('defaultAmazonPay', 5);
        fetch(`/api/user/set_checkout_session/${this.$route.query.amazonCheckoutSessionId}`)
          .then(() => {
            fetch('/api/user/get_checkout_session')
              .then((res) => res.json())
              .then((res) => {
                this.payMethod = res.payMethod;
                // お支払方法変更ボタンを生成
                this.renderChangePaymentButton(this.$route.query.amazonCheckoutSessionId);
              });
          });
      } else {
        // ボタンを生成
        fetch('/api/user/button_signature')
          .then((res) => res.json())
          .then((res) => {
            this.renderPayButton(res.signature, JSON.stringify(res.payloadJSON));
          });
      }
    });
  },
  methods: {
    renderPayButton(signature, payloadJSON) {
      window.amazon.Pay.renderButton('#AmazonPayButton', {
        merchantId: process.env.VUE_APP_MERCHANT_ID,
        publicKeyId: process.env.VUE_APP_PUBLIC_KEY_ID,
        ledgerCurrency: process.env.VUE_APP_LEDGER_CURRENCY,
        checkoutLanguage: process.env.VUE_APP_CHECKOUT_LANGUAGE,
        productType: 'PayOnly',
        placement: 'Other',
        buttonColor: 'Gold',
        sandbox: process.env.VUE_APP_SAND_BOX === 'true',
        createCheckoutSessionConfig: {
          payloadJSON,
          signature,
        },
      });
    },
    renderChangePaymentButton(sessionId) {
      window.amazon.Pay.bindChangeAction('#ChangePayment', {
        amazonCheckoutSessionId: sessionId,
        changeAction: 'changePayment',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#AmazonPayButton {
  margin: 10px auto 0;
}
.pay_method {
  color: $white;
}
.btn_area {
  display: flex;
  justify-content: center;
}
.square-button {
  width: 40%;
}
</style>
